import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import OfferFeeCatalogListItemComponent from './OfferFeeCatalogListItemComponent';
import OfferFeeCatalogListItemComponentWithNegotiation from './OfferFeeCatalogListItemComponentWithNegotiation';
import { loadUserGroups } from 'features/userProfile/userGroups/actionCreators';
import { IncomeSchemaFeeApprovalStatus } from '../../../../../../constants/incomeSchema';

const OfferFeeCatalogListItemContainer = ({
  fee,
  idx,
  onPropertyChange,
  onApprovalButtonClick,
  editRight,
  saving,
  schemaIsEligibleForNegotiation,
  userGroups,
  loaded,
  actions
}) => {
  const [hasApproveRightsLevel1, setHasApproveRightsLevel1] = useState(true);
  const [hasApproveRightsLevel2, setHasApproveRightsLevel2] = useState(true);

  useEffect(() => {
    actions.loadUserGroups();
  });
  useEffect(() => {
    function checkUserGroup(searchedGroupId, searchedGroups) {
      if (!userGroups.loaded) return false;
      let searchedGroupsArray = [];
      if (searchedGroups) searchedGroupsArray = searchedGroups.split(';');

      return (
        Array.isArray(userGroups.groups) &&
        (userGroups.groups.filter(item =>
          searchedGroupsArray.find(val => {
            return val === item.userGroupCode;
          })
        ).length > 0 ||
          (searchedGroupsArray.length === 0 && userGroups.groups.filter(item => item.userGroupId === searchedGroupId).length > 0))
      );
    }
    if (
      !schemaIsEligibleForNegotiation ||
      !fee ||
      !fee.approvalStatus ||
      (fee.approvalStatus &&
        fee.approvalStatus.localeCompare(IncomeSchemaFeeApprovalStatus.APPROVAL_1) &&
        fee.approvalStatus.localeCompare(IncomeSchemaFeeApprovalStatus.IN_PROGRESS))
    ) {
      setHasApproveRightsLevel1(false);
      setHasApproveRightsLevel2(false);
      return;
    }
    if (fee && fee.negotiationLimits && fee.negotiationLimits.length > 0 && (fee.percentProposed || fee.valueProposed)) {
      let limits = Object.assign([], fee.negotiationLimits);
      if (fee.percentProposed) {
        limits = limits.filter(
          item =>
            (!item.minCurrencyPercent || (item.minCurrencyPercent && item.minCurrencyPercent <= fee.percentProposed)) &&
            (!item.maxCurrencyPercent || (item.maxCurrencyPercent && item.maxCurrencyPercent >= fee.percentProposed))
        );
      }

      if (fee.valueProposed) {
        limits = limits.filter(
          item =>
            (!item.minCurrencyValue || (item.minCurrencyValue && item.minCurrencyValue <= fee.valueProposed)) &&
            (!item.maxCurrencyValue || (item.maxCurrencyValue && item.maxCurrencyValue >= fee.valueProposed))
        );
      }

      if (limits.length === 0) {
        setHasApproveRightsLevel1(false);
        setHasApproveRightsLevel2(false);
      } else {
        setHasApproveRightsLevel1(checkUserGroup(limits[0].firstApprovalUserGroupId, limits[0].firstApprovalUserGroups));
        setHasApproveRightsLevel2(checkUserGroup(limits[0].secondApprovalUserGroupId, limits[0].secondApprovalUserGroups));
      }
    }
  }, [fee, schemaIsEligibleForNegotiation, loaded, userGroups]);

  const handleItemPropertyChange = prop => e => {
    onPropertyChange(idx, prop, e);
  };

  const handleApprovalButtons = prop => e => {
    onApprovalButtonClick(idx, prop, e);
  };

  return (
    <>
      {schemaIsEligibleForNegotiation && fee.approvalStatus && fee.approvalStatus !== "" ? (
        <OfferFeeCatalogListItemComponentWithNegotiation
          fee={fee}
          onPropertyChange={handleItemPropertyChange}
          handleApprovalButtons={handleApprovalButtons}
          idx={idx}
          editRight={editRight}
          saving={saving}
          hasApproveRightsLevel1={hasApproveRightsLevel1}
          hasApproveRightsLevel2={hasApproveRightsLevel2}
        />
      ) : (
        <OfferFeeCatalogListItemComponent
          fee={fee}
          onPropertyChange={handleItemPropertyChange}
          idx={idx}
          editRight={editRight}
          saving={saving}
        />
      )}
    </>
  );
};

OfferFeeCatalogListItemContainer.propTypes = {
  fee: PropTypes.object.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  idx: PropTypes.number.isRequired,
  onApprovalButtonClick: PropTypes.func.isRequired,
  editRight: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired,
  schemaIsEligibleForNegotiation: PropTypes.bool.isRequired,
  actions: PropTypes.object,
  userGroups: PropTypes.object,
  loaded: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    userGroups: state.userProfile.userGroups
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        loadUserGroups
      },
      dispatch
    )
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(OfferFeeCatalogListItemContainer);
